"use strict";

(function (global, factory) {
  factory(require("../froala_3.0.5/js/froala_editor"));
})(void 0, function (FE) {
  "use strict";

  FE = FE && FE.hasOwnProperty("default") ? FE["default"] : FE;
  FE.DefineIcon("quoteIcon", {
    NAME: "quote-left",
    template: "font_awesome"
  });
  FE.RegisterCommand("cpQuote", {
    title: "Quote",
    icon: "quoteIcon",
    focus: true,
    undo: true,
    refreshAfterCallback: true,
    callback: function callback() {
      FE.SelectFroalaText(this.selection.element());

      if (!this.selection.isCollapsed()) {
        if (this.selection.element().tagName == "Q") {
          this.format.remove("q");
        } else {
          this.format.apply("q");
        }
      }
    }
  });
});